import { personas } from "@/config/horizonscanning/options";
import type { PersonaId, WizardState } from "@/config/horizonscanning/types";
import { cn } from "@/utils/cn";

interface PersonaStepProps {
  state: WizardState;
  onChange: (patch: Partial<WizardState>) => void;
}

export function PersonaStep({ state, onChange }: PersonaStepProps) {
  return (
    <div className="flex flex-col gap-3" role="radiogroup" aria-label="I am">
      {personas.map((p) => (
        <button
          key={p.value}
          type="button"
          role="radio"
          aria-checked={state.persona === p.value}
          className={cn("r1-choice", state.persona === p.value && "r1-choice-selected")}
          onClick={() => onChange({ persona: p.value as PersonaId })}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
